import {
  WebChatAvatarType,
  WebChatCustomIcon,
  WebChatFontSize,
  WebChatIconType,
  WebChatPosition,
  WebChatSettings,
} from '@ucc/cc-common-ui';

export const MOCK_CONFIGURATION: WebChatSettings = {
  appKey: '',
  enabled: true,
  domainNames: [],
  language: 'en-US',
  theme: {
    autoGreeting: {
      enabled: true,
      messageOverride: 'Hey you! Click here!',
      delaySeconds: 1,
    },
    font: {
      size: WebChatFontSize.SMALL,
      family: 'Raleway',
    },
    color: '#EB5725',
    header: {
      messageOverride: 'Hey, what is your problem?',
    },
    avatar: {
      type: WebChatAvatarType.GENERIC,
      genericIconName: WebChatCustomIcon.SVG_PERSON_ACTIVE,
    },
    chatIcon: {
      type: WebChatIconType.GENERIC,
      genericIconName: WebChatCustomIcon.SVG_CHAT_DOTS_INACTIVE,
    },
    pagePosition: WebChatPosition.LEFT,
    webChatContactInformationSettings: {
      enabled: true,
      email: {
        displayed: true,
        required: true,
      },
      name: {
        displayed: true,
        required: true,
      },
      phoneNumber: {
        displayed: true,
        required: false,
      },
      customFields: [
        {
          field: 'Company name',
          required: false,
          displayed: true,
        },
      ],
    },
  },
};
